import React from 'react'

import texts from '../../../../common/texts.json'

import './index.css'

const ContentHeader = () => {
  return (
    <div className="wfs-disclaimer-content-header d-flex flex-column justify-content-between">
      <img
        src="/catalogo/images/sparkNoImage.svg"
        className="wfs-disclaimer__img--spark"
        alt={texts.COMMON.ALT_WALMART_SPARK}
      />
    </div>
  )
}

export default ContentHeader
